import styled from "styled-components"

const HiddenInfoStyled = styled.section`
  padding-bottom: 70px;
  @media (max-width: 880px) {
    padding-bottom: 0;
  }
  .descirption--small {
    max-width: 700px;
    margin: 0 auto;
  }
  .container {
    /* display: flex;
    justify-content: space-between;
    flex-wrap: wrap; */
  }
  .hiddenInfo__wrapper {
    padding: 70px 70px 0;
    @media (max-width: 1080px) {
      padding: 20px 40px 0;
    }
    @media (max-width: 880px) {
      padding: 20px 0px 0;
    }
  }
  .hiddenInfo__item {
    display: flex;
    position: relative;
    @media (max-width: 1080px) {
      flex-direction: column;
    }
  }
  .hiddenInfo__item__heading {
    width: calc(100% - 400px);
    position: relative;
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    margin-bottom: 25px;
    cursor: pointer;
    color: #000;
    transition: 0.3s color, 0.3s opacity;
    @media (max-width: 1080px) {
      width: 100%;
      margin-bottom: 10px;
      font-size: 20px;
    }
    @media (max-width: 880px) {
    }
    &:hover {
      opacity: 0.7;
    }
    span {
      background: #fff;
      position: relative;
      z-index: 5;
      padding-right: 10px;
    }
    &:after {
      content: "";
      transition: 0.3s all;
      max-width: 0;
      left: 0;
      right: 20px;
      height: 1px;
      display: block;
      position: absolute;
      top: 50%;
      background: #707070;
      @media (max-width: 1080px) {
        content: unset;
      }
    }
  }
  .hiddenInfo__item__description {
    max-width: 400px;
    width: 100%;
    max-height: 0px;
    overflow: hidden;
    transition: 0.4s all 0.2s;
    margin: 10px 0 0;
    font-size: 18px;
    font-weight: 300;
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0;
    @media (max-width: 1080px) {
      position: relative;
      max-width: 100%;
      margin-bottom: 10px;
    }
    @media (max-width: 880px) {
      margin-top: 0;
      margin-bottom: 20px;
      font-size: 18px;
    }
  }
  .hiddenInfo__item--active {
    .hiddenInfo__item__description {
      max-height: 100px;
      position: absolute;
      right: 0;
      top: 0;
      opacity: 1;
      @media (max-width: 1080px) {
        position: relative;
      }
    }
    .hiddenInfo__item__heading {
      &:after {
        max-width: 100%;
      }
    }
  }
`

export default HiddenInfoStyled
